<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-9 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">Alarm</h2>
					</div>
				</div>
			</div>
		</div>
		<!-- tabs -->

		<!-- Table Container Card -->
		<b-card no-body class="mb-2">
			<b-tabs class="m-2" lazy>
				<b-tab active>
					<template #title>
						<div>
							<b-img
								:src="require('@/assets/images/svg/feed-supplement.svg')"
								style="margin-right: 7px; width: 20px"
							/>
							<span>Feeding</span>
						</div>
					</template>
					<FeedAlarm />
				</b-tab>
				<b-tab lazy>
					<template #title>
						<div>
							<b-img
								:src="require('@/assets/images/svg/vaccine.svg')"
								style="margin-right: 7px; width: 20px"
							/>
							<span>Vaccine</span>
						</div>
					</template>

					<VaccineAlarm />
				</b-tab>
				<b-tab lazy>
					<template #title>
						<div>
							<b-img
								:src="require('@/assets/images/svg/medicine.svg')"
								style="margin-right: 7px; width: 20px"
							/>
							<span>Medicine</span>
						</div>
					</template>
					<MedicineAlarm />
				</b-tab>
			</b-tabs>
		</b-card>
	</div>
</template>

<script>


import vSelect from "vue-select";
import FeedAlarm from "./FeedAlarm.vue";
import MedicineAlarm from "./MedicineAlarm.vue";
import VaccineAlarm from "./VaccineAlarm.vue";
export default {
	components: {
		vSelect,
		FeedAlarm,
		MedicineAlarm,
		VaccineAlarm,
	},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.per-page-selector {
	width: 90px;
}

.invoice-filter-select {
	min-width: 190px;

	::v-deep .vs__selected-options {
		flex-wrap: nowrap;
	}

	::v-deep .vs__selected {
		width: 100px;
	}
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
